import { render, staticRenderFns } from "./DeprovisionStatus.vue?vue&type=template&id=851f1214&scoped=true&"
import script from "./DeprovisionStatus.vue?vue&type=script&lang=js&"
export * from "./DeprovisionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f1214",
  null
  
)

export default component.exports